import React from 'react';
import {
  FaAngleDoubleRight,
  FaArrowRight,
  FaCheckCircle,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const TermsConditionDetails = () => {
  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area pd-top-120 pd-bottom-90">
        <div className="container">
          <div className="row">
            
            <div className="col-lg-12">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  
                  <div className="details">
                   
                  <ol>
 	<li><strong> Introduction</strong></li>
</ol>
Welcome to BhavanyaTravel Mart Pvt Ltd. These terms and conditions govern your use of our services and website. By accessing or using our website and services, you agree to comply with these terms. If you do not agree with any of the terms, please do not use our services.
<ol start="2">
 	<li><strong> Services Provided</strong></li>
</ol>
BhavanyaTravel Mart Pvt Ltd offers travel-related services including, but not limited to, travel bookings, tour packages, accommodation, transport, and other related services. Our services are available to individuals and organizations subject to the availability of products and services.
<ol start="3">
 	<li><strong> Booking and Payment Terms</strong></li>
</ol>
<ul>
 	<li><strong>Booking Confirmation</strong>: Your booking will be confirmed once the payment has been processed and you receive a confirmation email or notification from us.</li>
 	<li><strong>Payment Methods</strong>: Payments for bookings can be made through credit/debit cards, bank transfers, or other available payment methods as per the details on the website.</li>
 	<li><strong>Pricing</strong>: All prices on the website are in [Currency] and include applicable taxes unless stated otherwise. Prices are subject to change without notice, but the price applicable at the time of booking will apply.</li>
 	<li><strong>Refund and Cancellation Policy</strong>: Cancellation policies vary depending on the type of service booked. Please refer to our [Cancellation Policy Page] for specific details on refunds and cancellations.</li>
</ul>
<ol start="4">
 	<li><strong> User Obligations</strong></li>
</ol>
By using our services, you agree to:
<ul>
 	<li>Provide accurate and up-to-date information during the booking process.</li>
 	<li>Comply with all applicable laws and regulations regarding travel, including passport, visa, and customs requirements.</li>
 	<li>Be responsible for your actions while using our services and adhere to any rules or policies related to the services you book.</li>
</ul>
<ol start="5">
 	<li><strong> Changes to Bookings</strong></li>
</ol>
<ul>
 	<li><strong>Modification Requests</strong>: Requests for changes to your bookings must be submitted to us in advance. Changes are subject to availability and additional charges may apply.</li>
 	<li><strong>Travel Changes</strong>: We reserve the right to change the itinerary or services in case of unavoidable circumstances. If we make significant changes to your booking, you will be notified and provided with options for alternative arrangements or a refund.</li>
</ul>
<ol start="6">
 	<li><strong> Liability and Limitations</strong></li>
</ol>
<ul>
 	<li>BhavanyaTravel Mart Pvt Ltd is not responsible for any loss, damage, or injury arising from the use of our services unless it is caused directly by our negligence or breach of duty.</li>
 	<li>We are not responsible for any cancellations, delays, or changes to services due to factors beyond our control, such as natural disasters, strikes, or government regulations.</li>
</ul>
<ol start="7">
 	<li><strong> Privacy and Data Protection</strong></li>
</ol>
We value your privacy and are committed to protecting your personal information. By using our services, you consent to the collection and use of personal data as outlined in our [Privacy Policy].
<ol start="8">
 	<li><strong> Third-Party Providers</strong></li>
</ol>
Our services may involve third-party providers (e.g., airlines, hotels, transport companies). We are not responsible for their actions, policies, or performance. Any disputes with third-party providers should be resolved directly with them.
<ol start="9">
 	<li><strong> Force Majeure</strong></li>
</ol>
BhavanyaTravel Mart Pvt Ltd will not be held responsible for failure or delay in fulfilling our obligations due to circumstances beyond our control, including but not limited to natural disasters, government actions, or unforeseen disruptions to services.
<ol start="10">
 	<li><strong> Termination of Services</strong></li>
</ol>
We reserve the right to suspend or terminate your access to our services if we believe you have violated any of these terms and conditions, without prior notice.
<ol start="11">
 	<li><strong> Governing Law</strong></li>
</ol>
These terms and conditions are governed by and construed in accordance with the laws of [Country], and any disputes will be subject to the exclusive jurisdiction of the courts in [Location].
<ol start="12">
 	<li><strong> Changes to the Terms and Conditions</strong></li>
</ol>
We may update these terms and conditions from time to time. Any changes will be posted on this page, and it is your responsibility to review them periodically.
<ol start="13">
 	<li><strong> Contact Us</strong></li>
</ol>
If you have any questions or concerns about these terms and conditions, please contact us at:
<ul>
 	<li>Email: info@bhavanyatravelmart.com</li>
 	<li>Phone:  6363169466</li>
</ul>
<strong>Acknowledgment</strong>
<p>By using BhavanyaTravel Mart Pvt Ltd’s services, you acknowledge that you have read, understood, and agree to abide by these terms and conditions.
</p>

                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
};

export default TermsConditionDetails;